import React, { Component } from 'react';
import classNames from 'classnames';

class QuestionTabItem extends Component {
    constructor(props) {
        super(props);

        this.onClickItem = this.onClickItem.bind(this);
    }

    onClickItem(e) {
        e.preventDefault();
        const { selectedId, categoryInfo } = this.props;
        if (selectedId !== categoryInfo.id) {
            this.props.onClickItem(categoryInfo);
        }
    }

    render() {
        const { categoryInfo, selectedId } = this.props;
        const isClick = selectedId === categoryInfo.id;
        return (
            <li className={classNames({ on: isClick })}>
                <a
                    id={`faq-tab-${categoryInfo.name}`}
                    href="#"
                    onClick={this.onClickItem}
                >
                    <span>{categoryInfo.name}</span>
                </a>
            </li>
        );
    }
}

export default QuestionTabItem;
